import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AssetWizardModalPage } from './asset-wizard-modal.page';
import { QuizAssetWizardComponent } from './quiz-asset-wizard/quiz-asset-wizard.component';
import { StepQuizDetailsComponent } from './quiz-asset-wizard/step-quiz-details/step-quiz-details.component';
import { StepQuizQuestionsComponent } from './quiz-asset-wizard/step-quiz-questions/step-quiz-questions.component';
import { StepQuizQuestionPropertiesComponent } from './quiz-asset-wizard/step-quiz-question-properties/step-quiz-question-properties.component';
import { StepQuizConfirmationComponent } from './quiz-asset-wizard/step-quiz-confirmation/step-quiz-confirmation.component';
import { StepQuizResultsComponent } from './quiz-asset-wizard/step-quiz-results/step-quiz-results.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from 'src/app/callback.pipes.module';
import { QuestionAssetWizardComponent } from './question-asset-wizard/question-asset-wizard.component';
import { StepQuestionDetailsComponent } from './question-asset-wizard/step-question-details/step-question-details.component';
import { StepQuestionPropertiesComponent } from './question-asset-wizard/step-question-properties/step-question-properties.component';
import { StepHelpComponent } from './quiz-asset-wizard/step-help/step-help.component';
import { StepQuestionHelpComponent } from './question-asset-wizard/step-question-help/step-question-help.component';
import { ResourceDirectivesModule } from 'src/app/directives/resource-directives.module';
import { InformationPopupComponentModule } from 'src/app/popovers/information-popup/information-popup.module';
import { TextAssetWizardComponent } from './text-asset-wizard/text-asset-wizard.component';
import { ImageAssetWizardComponent } from './image-asset-wizard/image-asset-wizard.component';
import { VideoAssetWizardComponent } from './video-asset-wizard/video-asset-wizard.component';
import { Model3dAssetWizardComponent } from './model3d-asset-wizard/model3d-asset-wizard.component';
import { SelectionAssetWizardComponent } from './selection-asset-wizard/selection-asset-wizard.component';
import { AudioAssetWizardComponent } from './audio-asset-wizard/audio-asset-wizard.component';
import { HotspotAssetWizardComponent } from './hotspot-asset-wizard/hotspot-asset-wizard.component';
import { TextDetailsComponent } from './text-asset-wizard/text-details/text-details.component';
import { TextHelpComponent } from './text-asset-wizard/text-help/text-help.component';
import { ImageHelpComponent } from './image-asset-wizard/image-help/image-help.component';
import { ImageDetailsComponent } from './image-asset-wizard/image-details/image-details.component';
import { ImageActionsComponent } from './image-asset-wizard/image-actions/image-actions.component';
import { VideoDetailsComponent } from './video-asset-wizard/video-details/video-details.component';
import { VideoHelpComponent } from './video-asset-wizard/video-help/video-help.component';
import { VideoActionsComponent } from './video-asset-wizard/video-actions/video-actions.component';
import { Model3dHelpComponent } from './model3d-asset-wizard/model3d-help/model3d-help.component';
import { Model3dDetailsComponent } from './model3d-asset-wizard/model3d-details/model3d-details.component';
import { Model3dActionsComponent } from './model3d-asset-wizard/model3d-actions/model3d-actions.component';
import { SelectionDetailsComponent } from './selection-asset-wizard/selection-details/selection-details.component';
import { SelectionActionsComponent } from './selection-asset-wizard/selection-actions/selection-actions.component';
import { SelectionHelpComponent } from './selection-asset-wizard/selection-help/selection-help.component';
import { AudioDetailsComponent } from './audio-asset-wizard/audio-details/audio-details.component';
import { AudioActionsComponent } from './audio-asset-wizard/audio-actions/audio-actions.component';
import { AudioHelpComponent } from './audio-asset-wizard/audio-help/audio-help.component';
import { HotspotDetailsComponent } from './hotspot-asset-wizard/hotspot-details/hotspot-details.component';
import { HotspotHelpComponent } from './hotspot-asset-wizard/hotspot-help/hotspot-help.component';
import { HotspotActionsComponent } from './hotspot-asset-wizard/hotspot-actions/hotspot-actions.component';
import { TextActionsComponent } from './text-asset-wizard/text-actions/text-actions.component';
import { TextOutcomesComponent } from './text-asset-wizard/text-outcomes/text-outcomes.component';
import { SelectionOutcomesComponent } from './selection-asset-wizard/selection-outcomes/selection-outcomes.component';
import { VideoOutcomesComponent } from './video-asset-wizard/video-outcomes/video-outcomes.component';
import { HotspotOutcomesComponent } from './hotspot-asset-wizard/hotspot-outcomes/hotspot-outcomes.component';
import { AudioOutcomesComponent } from './audio-asset-wizard/audio-outcomes/audio-outcomes.component';
import { Model3dOutcomesComponent } from './model3d-asset-wizard/model3d-outcomes/model3d-outcomes.component';
import { ImageOutcomesComponent } from './image-asset-wizard/image-outcomes/image-outcomes.component';
import { VideoMediaManagementComponent } from './video-asset-wizard/video-media-management/video-media-management.component';
import { ImageMediaManagementComponent } from './image-asset-wizard/image-media-management/image-media-management.component';
import { AudioMediaManagementComponent } from './audio-asset-wizard/audio-media-management/audio-media-management.component';
import { StepQuestionOutcomesComponent } from './question-asset-wizard/step-question-outcomes/step-question-outcomes.component';
import { StepQuizOutcomesComponent } from './quiz-asset-wizard/step-quiz-outcomes/step-quiz-outcomes.component';

const routes: Routes = [
  {
    path: '',
    component: AssetWizardModalPage
  }
];

@NgModule({
  imports: [
    ResourceDirectivesModule,
    CommonModule,
    FormsModule,
    IonicModule,
    NgxPaginationModule,
    PipesModule,
    RouterModule.forChild(routes),
    ColorPickerModule,
    InformationPopupComponentModule
  ],
  declarations: [
    AssetWizardModalPage,
    QuizAssetWizardComponent,
    StepQuizDetailsComponent,
    StepQuizQuestionsComponent,
    StepQuizQuestionPropertiesComponent,
    StepQuizConfirmationComponent,
    StepQuizResultsComponent,
    StepQuizOutcomesComponent,
    StepHelpComponent,
    QuestionAssetWizardComponent,
    StepQuestionDetailsComponent,
    StepQuestionPropertiesComponent,
    StepQuestionHelpComponent,
    StepQuestionOutcomesComponent,
    TextAssetWizardComponent,
    TextDetailsComponent,
    TextHelpComponent,
    TextActionsComponent,
    TextOutcomesComponent,
    ImageAssetWizardComponent,
    ImageHelpComponent,
    ImageOutcomesComponent,
    ImageDetailsComponent,
    ImageActionsComponent,
    ImageMediaManagementComponent,
    VideoAssetWizardComponent,
    VideoDetailsComponent,
    VideoHelpComponent,
    VideoActionsComponent,
    VideoMediaManagementComponent,
    VideoOutcomesComponent,
    Model3dAssetWizardComponent,
    Model3dHelpComponent,
    Model3dDetailsComponent,
    Model3dOutcomesComponent,
    Model3dActionsComponent,
    SelectionAssetWizardComponent,
    SelectionDetailsComponent,
    SelectionActionsComponent,
    SelectionHelpComponent,
    SelectionOutcomesComponent,
    AudioAssetWizardComponent,
    AudioDetailsComponent,
    AudioActionsComponent,
    AudioOutcomesComponent,
    AudioMediaManagementComponent,
    AudioHelpComponent,
    HotspotAssetWizardComponent,
    HotspotDetailsComponent,
    HotspotHelpComponent,
    HotspotActionsComponent,
    HotspotOutcomesComponent
  ]
})
export class AssetWizardModalPageModule { }
